import { render, staticRenderFns } from "./CardCustomFreeLikeMessage.vue?vue&type=template&id=75cc6a56&scoped=true&"
import script from "./CardCustomFreeLikeMessage.vue?vue&type=script&lang=js&"
export * from "./CardCustomFreeLikeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cc6a56",
  null
  
)

export default component.exports